export const ru = {
    'client-id': 'ClientID',
    'full-name': 'ФИО',
    login: 'Логин',
    products: 'Список управляемых продуктов'
};
